document.addEventListener('DOMContentLoaded', (event) => {
    // Helper functies voor cookies
    function setCookie(name, value, days) {
        const d = new Date();
        d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = "expires=" + d.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
        console.log(`Set cookie: ${name}=${value}; ${expires}`);
    }

    function getCookie(name) {
        const cname = name + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(cname) === 0) {
                return c.substring(cname.length, c.length);
            }
        }
        return "";
    }

    // Elementen selecteren
    const popupWrapper = document.getElementById('language-popup-wrapper');
    const popup = document.getElementById('language-popup');
    const openPopupButton = document.getElementById('open-language-popup');
    const closePopupButton = popup ? popup.querySelector('.language-popup__close') : null;

    if (!popup) {
        console.log('Language popup not found.');
        return; // Stop de uitvoering als de popup niet gevonden is
    }

    // Controleren of er al een taalkeuze is gemaakt
    const languageChoice = getCookie('language_choice');
    console.log('Language choice from cookie:', languageChoice);

    if (!languageChoice) {
        console.log('No language choice found. Showing popup.');
        popupWrapper.classList.remove('hidden');
        popupWrapper.classList.add('visible');
    } else {
        console.log('Language choice found:', languageChoice);
    }

    // Functie om de popup te openen
    openPopupButton.addEventListener('click', () => {
        popupWrapper.classList.remove('hidden');
        popupWrapper.classList.add('visible');
    });

    // Functie om de popup te sluiten
    if (closePopupButton) {
        closePopupButton.addEventListener('click', () => {
            popupWrapper.classList.add('hidden');
            popupWrapper.classList.remove('visible');
        });
    }

    // Functie om de popup te sluiten wanneer er buiten geklikt wordt
    window.addEventListener('click', (event) => {
        if (event.target === popupWrapper) {
            popupWrapper.classList.add('hidden');
            popupWrapper.classList.remove('visible');
        }
    });

    // Taalkeuze opslaan en navigeren
    document.querySelectorAll('.wpml-ls-link').forEach(link => {
        link.addEventListener('click', (event) => {
            event.preventDefault();  // Voorkom de standaard actie
            const languageItem = event.target.closest('.wpml-ls-item');
            if (languageItem) {
                const selectedLanguage = languageItem.classList.contains('wpml-ls-item-nl') ? 'nl' : 'fr';
                console.log('Language selected:', selectedLanguage);
                setCookie('language_choice', selectedLanguage, 5);
                // Navigeren naar de nieuwe pagina na het instellen van de cookie
                window.location.href = link.href;
            }
        });
    });
});
